// Layout.tsx
import { Box} from "@chakra-ui/react";

import PublicFooter from './PublicFooter'


interface PublicLayoutProps {
  children: React.ReactNode;
}



const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const onLogout = () => {};
  return (
    
    <Box>
      {/* <NavBar isAuthenticated={false} onLogout={onLogout} userInitials={null}  /> */}
      <Box as="main" minH="80vh"   mt="72px">
        {children} {/* Page content goes here */}
      </Box>
      <PublicFooter />
    </Box>
    
  );
};

export default PublicLayout;
